/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';


/* ++++++++++ --------------- CHANGE BADGE : STYLES --------------- ++++++++++ */
export default {
    emojipreview: {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToEm(8),
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minWidth: pxToEm(384),
      maxWidth: pxToEm(400),
      '& .emojicontainer': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: 'auto',
        minHeight: pxToEm(52),
        background: '#F7F8FC',
        borderRadius: pxToEm(12),
        gap: pxToEm(8),
        padding: `${pxToEm(8)} ${pxToEm(16)}`,
        boxSizing: 'content-box'
      },
      '& span': {
        fontSize: pxToEm(10)
      },
      '& h3': {
        fontSize: pxToEm(24),
        marginBottom: pxToEm(4),
        fontFamily: '"Source Serif Pro",Georgia, serif'
      },
      '& .emojiplaceholder': {
        borderRadius: '100px',
        background: '#D9D9D9',
        width: pxToEm(28),
        height: pxToEm(28)
      },
      '& .countplaceholder': {
        height: pxToEm(10),
        width: pxToEm(30),
        borderRadius: pxToEm(12),
        background: '#D9D9D9',
      },
      '& .emoji': {
        borderRadius: pxToEm(8),
        padding: pxToEm(2)
      }
    }
}
